import React, { Component } from "react";

import { inject, observer } from "mobx-react";
import { Link, withRouter} from "react-router-dom";
// import NumberFormat from "react-number-format";
// import moment from "moment";
import { BookingStatusType, BookingType } from "../../types/enum";
import "./BookingDetails.css";
import { Grid, Typography, Button, Tooltip, Checkbox,Menu, Snackbar, IconButton,MenuItem, CircularProgress } from "@material-ui/core";
import ResponsiveTable from "../table/ResponsiveTable";
import BookingStatusBadge from "./BookingStatusBadge";
import moment from "moment";
import ConfirmationModal from "../modal/ConfirmationModal";
import CloseIcon from "@material-ui/icons/Close";

import { ProfileType, RosterDividendType, LineupStatusType } from "../../types/enum";

import currencyHelper from '../../helper/currency';
import { Fragment } from "react";
import CheckCircle from "@material-ui/icons/CheckCircle";
import DirectionsIcon from "@material-ui/icons/Directions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Edit";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import PrintIcon from "@material-ui/icons/Print";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GetAppIcon from "@material-ui/icons/GetApp";
import bookingCalculationHelper from "../../helper/bookingCalculationHelper"
import PrintModal from "./PrintModal.js/PrintModal";


const BOOKING_STATUS = ["Completed", "Cancelled"];

@inject("profileStore", "bookingRequestStore", "templateStore", "reportStore")
@withRouter
@observer
class BookingCompleted extends Component {
    state = {
        cancelBookingModalState: false,
        declineBookingModalState: false,
        columns: [],
        booking: undefined,
        duplicateModalState: true,
        duplicateModalState: null,
        openDuplicateSnackbar: false,
        duplicateBooking: undefined,
        actionAnchor: [],
        isLoading: false,
        selectedBookings: [],
        isExporting: false,
        showPrintOption: false
    };

    rows = [];

    componentDidMount() {
        const { completed } = this.props.bookingRequestStore;
        if (this.props.profileType === "agent") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentFee", label: <Tooltip title="Agent Fee"><span>Agent Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: <Tooltip title="Superannuation Fee"><span>Super Fee</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "musician") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate:true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "14%" },
                    { key: "actName", label: "Act Name", width: "14%" },
                    { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "9%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, width: "9%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: "Super Fee", sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "7%" }
                ]
            });
        } else if (this.props.profileType === "staff") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    { key: "gigFee", label: "Gig Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } }, 
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },  
                    // { key: "acknowledge", label: "Acknowledged", width: "15%", style: { textAlign: "center" } },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "10%" }
                ]
            });
        } else if (this.props.profileType === "PrivateHire") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    { key: "gigFee", label: "Gig Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } }, 
                    // { key: "acknowledge", label: "Acknowledged", width: "15%", style: { textAlign: "center" } },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "10%" }
                ]
            });
        }
    }

    loadCompletedGigs = (page) => {
        this.props.bookingRequestStore.showLoadingState()
        const {
            currentProfile
        } = this.props.profileStore;
        this.props.bookingRequestStore.getCompletedGigs(currentProfile?.id, page).then(() => {
           
        }).finally(() => {
            this.props.bookingRequestStore.hideLoadingState()
        });
        
    }

    handleShowMore = e => {
        var page = parseInt(this.props.bookingRequestStore.completedPage) + 1
        this.loadCompletedGigs(page)
    };

    setActionAnchor = (element, bookingId) => {
        var tempAnchor = [];
        tempAnchor[bookingId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAchnor = bookingId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };

    handleOpenDuplicateBookingModal = booking => this.setState({ duplicateModalState: true, duplicateBooking: booking, actionAnchor: [] });
    handleCloseDuplicateBookingModal = () => {
        this.setState({
            ...this.state,
            duplicateModalState: false,
            duplicateBooking: null
        });
    };
    handleDupicateRequest = () => {
        const { duplicateBooking } = this.state;
        const bookingRequestId = duplicateBooking?.bookingRequests?.filter(x => !x.deleted)[0]?.id || 0;

        this.props.bookingRequestStore.getDetailBookingCalendar(duplicateBooking.id, bookingRequestId)
            .then(() => {
                const freshBooking = this.props.bookingRequestStore.bookingDetail;
                this.props.bookingRequestStore.setDuplicateBooking(freshBooking);

                this.props.history.push(
                    `/booking/new?actId=${freshBooking?.actId ? freshBooking?.actId : "undefined"}&duplicateBooking=${true}&venueId=${freshBooking?.venueId ? freshBooking?.venueId : "undefined"}&dateStart=${freshBooking?.dateStart ? moment(freshBooking?.dateStart, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY")}`,
                    { from: 'fromBookingStation' }
                );
                this.handleCloseDuplicateBookingModal();
                this.setState({ openDuplicateSnackbar: true });
            });
    };

    handleSnackbarEditClose = (event, reason) => {
        this.setState({ openDuplicateSnackbar: false });
    };

    getCheckedRows = rows => this.setState({ selectedBookings: rows });

    openPrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: true
        })
    }

    closePrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: false
        })
    }

    getBookingStatus = booking => {
        if (booking.status === BookingStatusType.Cancelled.ordinal) {
            return "Cancelled";
        }
        return "Completed";
    };

    exportToCSV = () => {
        const { selectedBookings } = this.state;
        const { completed } = this.props.bookingRequestStore;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        this.setState({ isExporting: true });
        
        try {
            const selectedIds = selectedBookings.map(row => row.id);
            const originalBookings = completed.filter(booking => selectedIds.includes(booking.id));
            
            const data = originalBookings.map(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                const venueName = booking.venueName || booking.venue?.profileName || "";
                const venueAddress = booking.venue?.street1 
                    ? `${booking.venue.street1}${booking.venue.city ? ', ' + booking.venue.city : ''}${booking.venue.state ? ', ' + booking.venue.state : ''}`
                    : "";
                
                return {
                    date: moment(booking.dateStart).format("DD/MM/YYYY"),
                    timeStart: moment(booking.timeStart, "HH:mm:ss").format("hh:mm A"),
                    timeEnd: moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A"),
                    venueName: venueName,
                    venueAddress: venueAddress,
                    actName: booking.actName || booking.act?.actName || "",
                    status: this.getBookingStatus(booking),
                    venueClientFee: parseFloat(collectedFee.gigFee || 0).toFixed(2),
                    agentFee: parseFloat(collectedFee.agentFeeNumber || 0).toFixed(2),
                    performanceFee: parseFloat(collectedFee.performanceFee || booking.actFee || 0).toFixed(2),
                    invoiceAmount: parseFloat(collectedFee.feePaidToActNumber || 0).toFixed(2)
                };
            });

            const headers = ["Date", "Time Start", "Time End", "Venue Name", "Venue Address", "Act Name", "Status", "Venue/Client Fee", "Agent Fee", "Performance Fee", "Invoice Amount"];
            
            const csvContent = [
                headers.join(","),
                ...data.map(row => [
                    `"${row.date}"`,
                    `"${row.timeStart}"`,
                    `"${row.timeEnd}"`,
                    `"${row.venueName.replace(/"/g, '""')}"`,
                    `"${row.venueAddress.replace(/"/g, '""')}"`,
                    `"${row.actName.replace(/"/g, '""')}"`,
                    `"${row.status}"`,
                    row.venueClientFee,
                    row.agentFee,
                    row.performanceFee,
                    row.invoiceAmount
                ].join(","))
            ].join("\n");

            const agencyName = currentProfile?.profileName || "Agency";
            
            let venueLabel = "All Venues";
            if (venueId && originalBookings.length > 0) {
                const firstBooking = originalBookings[0];
                venueLabel = firstBooking.venueName || firstBooking.venue?.profileName || "All Venues";
            }
            
            const dates = originalBookings.map(b => moment(b.dateStart));
            let dateRange = moment().format("YYYY-MM-DD");
            if (dates.length > 0) {
                const minDate = moment.min(dates).format("DD-MM-YYYY");
                const maxDate = moment.max(dates).format("DD-MM-YYYY");
                dateRange = minDate === maxDate ? minDate : `${minDate} to ${maxDate}`;
            }
            
            const safeAgencyName = agencyName.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const safeVenueLabel = venueLabel.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const filename = `${safeAgencyName} - ${safeVenueLabel} - Completed Gigs - ${dateRange}.csv`;

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting CSV:", error);
            this.props.templateStore.openSnackbar("Error exporting CSV. Please try again.");
        } finally {
            this.setState({ isExporting: false });
        }
    };

    renderTableCustomActions = () => {
        const { selectedBookings, isExporting } = this.state;
        const isDisabled = !selectedBookings || selectedBookings.length === 0;
        return (
            <Fragment>
                <Button onClick = { this.openPrintOptionModal } disabled = { isDisabled } style={{ color: !isDisabled ? "#fff" : undefined }}>
                    <PrintIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    Print
                </Button>
                <Button 
                    onClick={this.exportToCSV} 
                    disabled={isDisabled || isExporting} 
                    style={{ color: !isDisabled && !isExporting ? "#fff" : undefined, marginLeft: 8 }}
                >
                    {isExporting ? (
                        <CircularProgress size={20} style={{ color: "#fff", marginRight: 4 }} />
                    ) : (
                        <GetAppIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    )}
                    {isExporting ? "Exporting..." : "Download CSV"}
                </Button>
            </Fragment>
        )
    };

    renderFooterRow = () => {
        let { completed } = this.props.bookingRequestStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (venueId) {
            completed = completed.filter(x => x.venueId === venueId);
        }
        var totalFee = 0;
        var totalActFee = 0;
        var totalAgentFee = 0;
        var totalMyFee = 0
        var totalSuperFee = 0;
        var totalFeedPaidtoAct = 0
        

        // completed.forEach( booking => {
        //     let linuep = booking?.lineups?.find(x => x.profileId === currentProfile?.id);
        //     var musicianFee = parseFloat(booking.gigFee) - totalFee
        //     const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

        //     let adminFeeRoster = 0
        //     let totalRosterFeeAdmin = 0
        //     booking?.act?.actRoster?.forEach(actRoster => {
        //         let feeCount = 0
        //         if(actRoster.dividendType === RosterDividendType.Percentage.ordinal){
        //             feeCount = actRoster.dividendAmount /100 * booking.actFee;
        //         }else {
        //             feeCount = actRoster.dividendAmount;
        //         }
        //         totalRosterFeeAdmin = totalRosterFeeAdmin + feeCount
        //     })
        //     adminFeeRoster = booking.actFee - totalRosterFeeAdmin
        //     if(currentProfile?.type === ProfileType.Musician.ordinal && !booking?.lineups?.length){
        //         let actRoster = booking?.act?.actRoster?.filter(x => x.rosters.some(t => t.profileId === currentProfile?.id));
               
        //         if(actRoster?.length){
        //             if(actRoster[0].dividendType === RosterDividendType.Percentage.ordinal){
        //                 musicianFee = actRoster[0].dividendAmount /100 * booking.actFee;
        //             }else {
        //                 musicianFee = actRoster[0].dividendAmount;
        //             }
        //             if(this.props.profileType === 'musician'){
        //                 if(booking?.act?.actAdminId === currentProfile?.id){
        //                     musicianFee = parseFloat(musicianFee) + parseFloat(adminFeeRoster)
        //                 }
        //             }
        //         }else{
        //             musicianFee = booking.actFee
        //             booking?.act?.actRoster?.forEach(item => {
        //                 var rosterFee = 0
        //                 if(item.dividendType === RosterDividendType.Percentage.ordinal){
        //                     rosterFee = item.dividendAmount /100 * booking.actFee;
        //                 }else {
        //                     rosterFee = item.dividendAmount;
        //                 }
        //                 musicianFee = musicianFee - rosterFee
        //             });
        //         }
        //     }
             
        //     var totalRosterFee = 0

        //     booking?.lineups?.forEach(lineUp => {
        //         totalRosterFee = parseFloat(totalRosterFee) + parseFloat(lineUp.fee) 
        //     })
        //     var adminFee = booking.actFee - totalRosterFee
        //     var calculateFee = linuep?.fee ?  linuep?.fee : 0
        //     if(this.props.profileType === 'musician'){
        //         if(booking?.act?.actAdminId === currentProfile?.id){
        //             calculateFee = parseFloat(calculateFee) + parseFloat(adminFee)
        //         }
        //     }
            
        //     let myFee = linuep?.fee ? calculateFee: isEntertainerBookings ? booking.gigFee : (booking.isAdmin && !linuep) ? musicianFee : booking.actFee;
          
        //     let actOwner = booking.act?.userId === currentProfile?.userId; 

        //     totalFee += (booking.viewOnly) ? 0 : (profileType === "agent" || profileType === "staff") && booking.isApproved ? Number(booking.gigFee) + Number(booking.extraGigFee) : Number(booking.gigFee);
        //     totalActFee += profileType === "musician" && !actOwner ? 0 : Number(booking.actFee);
        //     totalAgentFee += Number(booking.agentCommissionAmount);
        //     totalMyFee += Number(myFee);
        // });

         completed.map(booking => {
    
        let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking.act.actAdminId === currentProfile?.id;

        var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
        let actOwner = booking.act?.userId === currentProfile?.userId;

        let displayFeeAmount;

        const isAgentOrStaff = (profileType === "agent" || profileType === "staff");

        const shouldShowExpandedFee = isAgentOrStaff && booking.isApproved;

        if (shouldShowExpandedFee) {
            displayFeeAmount = collectedFee.gigFee + booking.extraGigFee;
        } else if (agentActOwner) {
            displayFeeAmount = collectedFee.performanceFee;
        } else {
            displayFeeAmount = collectedFee.gigFee;
        }

        let displayActFeeAmount;
        if (agentActOwner) {
            displayActFeeAmount = booking.actFee;
        } else if (this.props.profileType === "musician" && !actOwner) {
            displayActFeeAmount = 0;
        } else {
            displayActFeeAmount = booking.actFee;
        }

        totalFee = totalFee + parseFloat(displayFeeAmount);
        totalActFee = totalActFee + parseFloat(displayActFeeAmount)
        totalAgentFee = totalAgentFee + parseFloat(collectedFee.agentFeeNumber);
        totalMyFee = totalMyFee + this.props.profileType === 'musician' ? parseFloat(collectedFee.myFee) : 0;
        
        totalSuperFee = totalSuperFee + parseFloat(collectedFee.superFeeNumber)
        totalFeedPaidtoAct = totalFeedPaidtoAct + parseFloat(collectedFee.feePaidToActNumber)
        
    })

        return {
            gigFee: ( (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFee, 2)}`,
            actFee: ( (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalActFee, 2)}`,
            agentCommissionAmount: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            agentFee: ((currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            myFee: ((currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalMyFee, 2)}`,
            superFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalSuperFee, 2)}`,
            feePaidToAct: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFeedPaidtoAct, 2)}`,
            style: {
                textAlign: 'left'
            }
        }
    }

    renderMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentCommissionAmount}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.myFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-act">
                        <div className="mobile-gig-card-status">{row.status}</div>
                        {row.actName}
                    </div>
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    renderAgentMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-act" style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                    <div className="mobile-gig-card-status">{row.status}</div>
                    {row.actName}
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.actFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { completed } = this.props.bookingRequestStore;
        let { currentProfile } = this.props.profileStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        if (venueId) {
            completed = completed.filter(x => x.venueId === venueId);
            this.props.bookingRequestStore.setBookingsCount("completed", completed);
        }
        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                        <div>
                            <Typography variant="headline" component="h3" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                Completed Gigs
                                <Tooltip title={profileType === "musician" ? "This is the list of your completed gigs." : "This is the list of completed gigs."}>
                                    <HelpOutlineIcon style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} />
                                </Tooltip>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={12} className="booking-table-wrapper">
                        <ResponsiveTable
                            sortable={true}
                            selectable={profileType !== "musician"}
                            showToolbar={profileType !== "musician"}
                            customActions={this.renderTableCustomActions()}
                            getCheckedRows={this.getCheckedRows}
                            mobileSecondaryField="venue"
                            columns={this.state.columns}
                            mobileCardRenderer={profileType === "musician" ? this.renderMobileGigCard : profileType === "agent" ? this.renderAgentMobileGigCard : undefined}
                            rows={completed.map(booking => {
                                var row = {};
                                // row.date = date.getDate()+" "+this.props.templateStore.getMonth(date.getMonth())+" "+date.getFullYear();
                                
                                row.id = booking.id;
                                row.timeStart = booking.timeStart;
                                row.timeEnd = booking.timeEnd;
                                row.loadInStart = booking.loadInStart;
                                row.loadInEnd = booking.loadInEnd;
                                row.loadInTime = booking.loadInTime;
                                row.soundCheckStart = booking.soundCheckStart;
                                row.soundCheckEnd = booking.soundCheckEnd;
                                row.soundCheckTime = booking.soundCheckTime;
                                row.notes = booking.notes;
                                row.productionNotes = booking.productionNotes;
                                row.gigRequirements = booking.gigRequirements;
                                row.agentContract = booking.agentContract;
                                row.venueId = booking.venueId;
                                row.venueName = booking.venueName || booking.venue?.profileName;
                                
                                var formattedDate = moment(booking.dateStart).format("YYYY-MM-DD")
                                
                                
                                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;
                                let endTime = booking.timeEnd.length < 8 ? `0${booking.timeEnd}` : booking.timeEnd;
                                var finalDate= moment(formattedDate + ' ' + time)
                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                                row.date = {newFormat: 
                                    (
                                        <div className="gig-date-box">
                                            <div className="day-name">{booking.dateStart.format("ddd")}</div>
                                            <div className="date-number">{booking.dateStart.format("DD")}</div>
                                            <div className="month">{booking.dateStart.format("MMM YYYY")}</div>
                                            <div className="time-range">{`${moment(time, 'HH:mm:ss').format('h:mm A')} - ${moment(endTime, 'HH:mm:ss').format('h:mm A')}`}</div>
                                        </div>
                                    ), value: finalDate};
                                row.venue = (
                                    <div>
                                        <span style={{fontWeight: 600}}>{booking.venue ? booking.venue.profileName : booking.venueName}</span>
                                        <br />
                                        <small style={{color: '#888'}}>{booking.venueAddress}</small>
                                    </div>
                                );
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                // row.address = booking.venueAddress;
                                row.agentName = booking.agentName;
                                row.time = booking.timeStart.substring(0, 5);
                                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> :
                                (booking.viewOnly) || (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices)
                                    ? <i class="far fa-eye-slash"></i>
                                    : `${currentProfile?.currencySymbol + ((profileType === "agent" || profileType === "staff") && booking.isApproved
                                        ? currencyHelper?.formatMoney(collectedFee.gigFee + booking.extraGigFee, 2) 
                                            : currencyHelper?.formatMoney(collectedFee.gigFee, 2))}`;
                                row.agentFee = collectedFee.agentFee
                                row.agentCommissionAmount = collectedFee.agentCommissionAmount
                                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

                                row.actName = profileType === "musician" ? (
                                    <div>
                                        <div className="gig-act-name">
                                            <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`}>
                                                {isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}
                                            </a>
                                        </div>
                                        {booking.act?.contactName && <div className="gig-act-contact">{booking.act?.contactName}</div>}
                                        {booking.act?.contactPhone && <div className="gig-act-contact">{booking.act?.contactPhone}</div>}
                                    </div>
                                ) : (
                                    <div>
                                        <Link target={"_blank"} to={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`}>{isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}</Link>
                                        <br />
                                        {booking.act && <small>Contact: {booking.act?.contactName}</small>}
                                    </div>
                                );

                                
                                
                                let linuep = booking?.lineups?.find(x => x.profileId === currentProfile?.id);
                                // let myFee = linuep?.fee ? linuep.fee : isEntertainerBookings ? booking.gigFee : booking.actFee
                                let actOwner = booking.act?.userId === currentProfile?.userId; 

                                row.actFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) ? <i className={"icon-eye-blocked"} /> : this.props.profileType === "musician" && !actOwner ? "" : currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2);


                                row.myFee = this.props.profileType === 'musician' && currentProfile?.currencySymbol + currencyHelper.formatMoney(collectedFee.myFee, 2);
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                row.superFee = collectedFee.superFee
                                row.feePaidToAct = collectedFee.feePaidToAct

                                row.acknowledge = booking.acknowledge ? (
                                    <Tooltip
                                        title={
                                            <span>
                                                Acknowledge By:{" "}
                                                {`${booking.acknowledgeBy ? booking.acknowledgeBy.firstName : ""} ${
                                                    booking.acknowledgeBy ? booking.acknowledgeBy.lastName : ""
                                                }`}
                                            </span>
                                        }
                                        placement="bottom"
                                    >
                                        <Checkbox checked={true} disableRipple={true} />
                                    </Tooltip>
                                ) : (
                                    <Checkbox checked={booking.acknowledge} disabled={true} />
                                );
                                row.isSendBookingDetails = booking.isSendBookingDetails ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div>  : null;
                                
                                const handleGetDirections = () => {
                                    const address = encodeURIComponent(booking.venueAddress || '');
                                    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
                                };
                                
                                const handleViewDetails = () => {
                                    let redirectUrl =
                                        booking.type === BookingType.Adhoc.ordinal
                                        ? `/privateBooking/${booking.id}/edit`
                                        : currentProfile?.type === ProfileType.Musician.ordinal
                                            ? `/musician/booking/${booking.id}/details`
                                            : currentProfile?.type === ProfileType.Agent.ordinal
                                                ? `/booking/${booking.id}/edit`
                                                : currentProfile?.type === ProfileType.Staff.ordinal
                                                    ? `/booking/${booking.id}/edit`
                                                    : "";
                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(redirectUrl, '_blank'):                         
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };
                                
                                row.action = profileType === "musician" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <VisibilityIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View Details
                                            </MenuItem>
                                            <MenuItem 
                                                onClick={() => { this.unsetActionAchnor(booking.id); handleGetDirections(); }}
                                                disabled={!booking.venueAddress}
                                            >
                                                <DirectionsIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Get Directions
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                ) : profileType === "agent" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View / Edit
                                            </MenuItem>
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenDuplicateBookingModal(booking); }}>
                                                <FileCopyIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Duplicate Booking
                                            </MenuItem>
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/${booking.id}/sendBookingEmail`); }}>
                                                    <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>✉</span>
                                                    Send Booking Details via Email
                                                </MenuItem>
                                            )}
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/printBookingDetails/${booking.id}`); }}>
                                                    <PrintIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Print Booking Details
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </div>
                                ) : (
                                    <div className="gig-actions">
                                        <Tooltip title={booking.venueAddress ? "Get Directions" : "No address available"}>
                                            <span>
                                                <IconButton 
                                                    className="gig-action-btn" 
                                                    onClick={handleGetDirections}
                                                    disabled={!booking.venueAddress}
                                                    style={!booking.venueAddress ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                                                >
                                                    <DirectionsIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="View Details">
                                            <IconButton 
                                                className="gig-action-btn" 
                                                onClick={handleViewDetails}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (
                                            <Fragment>
                                                <Tooltip title="More Actions">
                                                    <IconButton 
                                                        className="gig-action-btn" 
                                                        onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                                    >
                                                        <span style={{fontSize: '18px', fontWeight: 'bold'}}>...</span>
                                                    </IconButton>
                                                </Tooltip>
                                                {booking.id && (
                                                    <Menu
                                                        open={this.state.actionAnchor[booking.id] != null}
                                                        onClose={() => this.unsetActionAchnor(booking.id)}
                                                        anchorEl={this.state.actionAnchor[booking.id]}
                                                    >
                                                        <MenuItem onClick={() => this.handleOpenDuplicateBookingModal(booking)}>Duplicate Booking</MenuItem>
                                                    </Menu>
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                );
                                row.status = (
                                    <BookingStatusBadge status={BOOKING_STATUS[booking.status === BookingStatusType.Cancelled.ordinal ? 1 : 0]} />
                                );
                                return row;
                            })}
                            footerRow = {
                                currentProfile?.type === ProfileType.Agent.ordinal ? 
                                    this.renderFooterRow() : undefined
                            }
                        />
                    </Grid>
                    <Grid item style={{marginTop: 25}} xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                            <Grid container direction="row" justify="center" alignItems="center">
                                {this.props.bookingRequestStore.showMoreCompleted ? (
                                    <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                        Show More
                                    </Button>
                                ) : null}
                            </Grid>
                        </Grid>
                </Grid>
                <ConfirmationModal
                    open={this.state.duplicateModalState}
                    message={`Are you sure you want to duplicate this booking - ${this.state.duplicateBooking?.title}?`}
                    closeHandler={this.handleCloseDuplicateBookingModal}
                    confirmationHandler={this.handleDupicateRequest}
                    declineHandler={this.handleCloseDuplicateBookingModal}
                    confirmationLabel="Duplicate"
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDuplicateSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarEditClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Booking {this.state.duplicateBooking?.title} duplicated</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
                <PrintModal 
                    open = { this.state.showPrintOption }
                    closeHandler = { this.closePrintOptionModal }
                    bookings = { this.state.selectedBookings }
                />
            </Fragment>
        );
    }
}

export default BookingCompleted;
